import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-16518562"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "months-grid" }
const _hoisted_2 = ["onClick"]

import { computed } from "vue";
import { generateMonthViewCell } from "../../generators";


export default /*#__PURE__*/_defineComponent({
  __name: 'months-grid',
  props: {
  /**Выбранный индекс месяца (0-11) */
  modelValue: { type: Number },
  /**Отображаемый год */
  viewYear: { type: Number, required: true },
  /**Используется в пикере выбора месяца */
  inMonthpicker: { type: Boolean, required: true },
},
  emits: ["update:modelValue"],
  setup(__props, { emit }) {

const props = __props;





/**Ячейки */
const cells = computed(() => generateMonthViewCell(props.viewYear));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cells.value, (cell) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "month-cell__container",
        onClick: ($event: any) => (emit('update:modelValue', cell.monthIndex))
      }, [
        _renderSlot(_ctx.$slots, "cell", { cell: cell }, () => [
          _createElementVNode("div", {
            class: _normalizeClass([
            'month-cell',
            {
              'is-selected': __props.inMonthpicker && __props.modelValue === cell.monthIndex,
              'is-current': __props.inMonthpicker
                ? cell.isCurrent
                : __props.modelValue === cell.monthIndex,
            },
          ])
          }, _toDisplayString(cell.text), 3)
        ])
      ], 8, _hoisted_2))
    }), 256))
  ]))
}
}

})